import { AnalyticsEvent, fireGtmEvent } from 'src/utils/new-analytics';

import { processDeferredEventsForSignIn } from './deferredEvents';

interface AuthBaseContext {
  loginStatus: 'logged-in' | 'logged-out';
}

export const auth = {
  login(context: AuthBaseContext) {
    fireGtmEvent(AnalyticsEvent.UserLogin, {
      loginStatus:
        // Map app enum to analytics value
        context.loginStatus === 'logged-in' ? 'LOGGED_IN' : 'LOGGED_OUT',
    });
  },
  userLoaded() {
    fireGtmEvent(AnalyticsEvent.UserLoaded, {});
    processDeferredEventsForSignIn();
  },
};
